export default {
  Clients: [],
  ClientView: {},
  PedidoView: {},
  SelectedClientEdit: {
    usuario: {
      usuario: '',
      email: '',
      nome: '',
      sobrenome: '',
      senha: '',
      csenha: ''
    },
    endereco: {
      cpf: '',
      celular: '',
      cep: '',
      bairro: '',
      endereco: '',
      numero: '',
      cidade: '',
      uf: ''
    }
  },
  Pedidos: [],
  PaymentBrick: true,
  PaymentStatus: true,
  PedidoAtual: [],
  NotasPedido: '',
  TryAgainPay: false,
  cupom: { codigo: '', valor: 0 },
  ClientValidate: {
    usuario: { $invalid: false, has: { $message: '', $invalid: false } },
    email: { $invalid: false, has: { $message: '', $invalid: false } },
    nome: { $invalid: false },
    sobrenome: { $invalid: false },
    cpf: { $invalid: false },
    celular: { $invalid: false },
    cep: { $invalid: false },
    bairro: { $invalid: false },
    endereco: { $invalid: false },
    numero: { $invalid: false },
    cidade: { $invalid: false },
    uf: { $invalid: false },
    senha: { $invalid: false },
    csenha: { $invalid: false }
  },
  EditClientValidate: {
    nome: { $invalid: false },
    sobrenome: { $invalid: false },
    cpf: { $invalid: false },
    celular: { $invalid: false },
    cep: { $invalid: false },
    bairro: { $invalid: false },
    endereco: { $invalid: false },
    numero: { $invalid: false },
    cidade: { $invalid: false },
    uf: { $invalid: false }
  },
  LoadPay: false,
  ValorFrete: 0,
  PixApproved: false
}
